module.exports = __webpack_public_path__ + "static/media/citroen.126da2be.png";